// Mock data for Detailing Disciples website

export const HERO_DATA = {
  title: "Detailing Disciples",
  subtitle: "Owner-Operated Premium Auto Detailing",
  tagline: "Paint-safe care. Owner-operated service. Simi Valley based.",
  heroImage: "https://images.unsplash.com/photo-1722850312872-52ebbd041a90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxibGFjayUyMHBvcnNjaGUlMjBsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBnbG9zc3l8ZW58MHx8fHwxNzg0NDE4MDYwfDA&ixlib=rb-4.1.0&q=85",
  phone: "(747) 320-7174",
  rating: 5.0,
  reviewCount: 20,
  reviewSources: "on Google and Yelp"
};

export const SERVICES_DATA = [
  {
    id: 1,
    name: "Basic Hand Wash / Maintenance Wash",
    description: "Professional hand wash using deionized RO water to avoid water spots. Brand new microfiber towels minimize swirl marks.",
    startingPrice: 65,
    priceRange: "$65 - $75",
    pricingNote: "Pricing based on vehicle size",
    duration: "1-1.5 hours",
    icon: "sparkles",
    features: [
      "Full hand wash with deionized RO water",
      "Brand new microfiber towels",
      "Rim and tire cleaning",
      "Silicon tire dressing",
      "Interior vacuum and wipe down"
    ],
    image: "https://images.pexels.com/photos/13446899/pexels-photo-13446899.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    pricing: {
      small: 65,
      large: 75
    }
  },
  {
    id: 2,
    name: "Mini Detail",
    description: "Everything from our Basic Wash plus protective sealant wax for exterior and light interior shampooing.",
    startingPrice: 150,
    priceRange: "$150 - $175",
    pricingNote: "Pricing based on vehicle size",
    duration: "2-2.5 hours",
    icon: "sparkles",
    features: [
      "Full hand wash with deionized RO water",
      "Brand new microfiber towels",
      "Rim and tire cleaning with silicon dressing",
      "Sealant wax for exterior protection",
      "Light interior shampooing",
      "Interior vacuum and wipe down"
    ],
    image: "https://images.unsplash.com/photo-1705079483667-844c6e5c6085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZ3xlbnwwfHx8fDE3NzMyNTI2NDV8MA&ixlib=rb-4.1.0&q=85",
    pricing: {
      small: 150,
      large: 175
    }
  },
  {
    id: 3,
    name: "Full Interior Detail",
    description: "Complete interior restoration with deep cleaning, shampooing, and conditioning. Every surface meticulously cleaned and protected.",
    startingPrice: 225,
    priceRange: "Starting at $225",
    pricingNote: "Pricing based on vehicle size and condition",
    duration: "3-4 hours",
    icon: "shield",
    features: [
      "Deep interior vacuum",
      "Full shampooing of carpets & upholstery",
      "Steam cleaning all surfaces",
      "Leather conditioning & protection",
      "Dashboard & console detailing",
      "Door jamb cleaning",
      "Glass cleaning (interior)",
      "Air vent detailing",
      "Pet hair removal",
      "Odor elimination treatment"
    ],
    image: "https://images.unsplash.com/photo-1714434087918-4b9abedef3c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3NzMyNTI2NTJ8MA&ixlib=rb-4.1.0&q=85",
    pricing: {
      starting: 225
    }
  },
  {
    id: 4,
    name: "Paint Correction",
    description: "Professional multi-stage paint correction to remove swirl marks, scratches, and oxidation. Restores your paint to showroom perfection. Each additional step: $199.",
    startingPrice: 299,
    priceRange: "$299 + $199 per additional step",
    pricingNote: "Stage 1 starts at $299, each additional step $199",
    duration: "4-8 hours",
    icon: "wand",
    features: [
      "Stage 1: Heavy cutting compound - $299",
      "Stage 2: Medium polish refinement - +$199",
      "Stage 3: Fine finishing polish - +$199",
      "Removes swirl marks & scratches",
      "Eliminates oxidation & haze",
      "Paint depth measurement",
      "Restores gloss and clarity",
      "Flexible multi-stage system"
    ],
    image: "https://images.unsplash.com/photo-1708805282676-0c15476eb8a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjYXIlMjBwYWludCUyMGNvcnJlY3Rpb258ZW58MHx8fHwxNzczMjUyNjQxfDA&ixlib=rb-4.1.0&q=85",
    pricing: {
      stage1: 299,
      stage2: 498,
      stage3: 697,
      perStep: 199
    }
  },
  {
    id: 5,
    name: "Ceramic Coating Packages",
    description: "Premium long-term paint protection with our Silver, Gold, and Platinum ceramic coating packages. Professional-grade coatings with multi-year warranties.",
    startingPrice: 999,
    priceRange: "Starting at $999",
    pricingNote: "Three package levels available",
    duration: "1-2 days",
    icon: "shield",
    features: [
      "Silver Package: 2-year protection",
      "Gold Package: 4-year protection",
      "Platinum Package: 6-year protection",
      "Paint correction included",
      "Hydrophobic properties",
      "UV ray protection",
      "Enhanced gloss & depth",
      "Full documentation included"
    ],
    image: "https://images.unsplash.com/photo-1711513503808-53380d724182?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3NzMyNTI2NTJ8MA&ixlib=rb-4.1.0&q=85",
    pricing: {
      silver: 999,
      gold: 1499,
      platinum: 1999
    },
    packages: [
      {
        name: "Silver Package",
        price: 999,
        duration: "2-Year Protection",
        features: [
          "Stage 1 paint correction",
          "Premium ceramic coating",
          "2-year warranty",
          "Maintenance kit included"
        ]
      },
      {
        name: "Gold Package",
        price: 1499,
        duration: "4-Year Protection",
        popular: true,
        features: [
          "Stage 2 paint correction",
          "Premium ceramic coating",
          "4-year warranty",
          "Wheel ceramic coating",
          "Maintenance kit included",
          "Annual inspection"
        ]
      },
      {
        name: "Platinum Package",
        price: 1999,
        duration: "6-Year Protection",
        features: [
          "Stage 3 paint correction",
          "Premium+ ceramic coating",
          "6-year warranty",
          "Wheel & glass ceramic coating",
          "Interior ceramic protection",
          "Premium maintenance kit",
          "Bi-annual inspections"
        ]
      }
    ]
  }
];

export const PACKAGES_DATA = [
  {
    id: 1,
    name: "Basic Hand Wash",
    price: 65,
    priceRange: "$65 - $75",
    duration: "1-1.5 hours",
    popular: false,
    features: [
      "Deionized RO water hand wash",
      "Brand new microfiber towels",
      "Rim & tire cleaning",
      "Silicon tire dressing",
      "Interior vacuum & wipe down"
    ]
  },
  {
    id: 2,
    name: "Mini Detail",
    price: 150,
    priceRange: "$150 - $175",
    duration: "2-2.5 hours",
    popular: true,
    features: [
      "Everything in Basic Hand Wash",
      "Sealant wax protection",
      "Light interior shampooing",
      "Enhanced exterior shine"
    ]
  },
  {
    id: 3,
    name: "Premium Detail",
    price: 299,
    priceRange: "$299 - $325",
    duration: "3-4 hours",
    popular: false,
    features: [
      "Everything in Basic Hand Wash",
      "Clay mitt decontamination",
      "Exterior trim restoration",
      "Interior full restoration",
      "Full shampooing & steam cleaning",
      "Vacuum every cranny & crevice",
      "6-month ceramic sealant"
    ]
  }
];

export const GALLERY_DATA = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_detailing-disciples/artifacts/37727kgf_IMG_9490.HEIC",
    after: "https://images.unsplash.com/photo-1708805282676-0c15476eb8a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjYXIlMjBwYWludCUyMGNvcnJlY3Rpb258ZW58MHx8fHwxNzczMjUyNjQxfDA&ixlib=rb-4.1.0&q=85",
    title: "Full Detail - BMW M3",
    description: "Pre-wash foam treatment and complete detailing transformation"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1708805282683-50a060eba80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxjYXIlMjBwYWludCUyMGNvcnJlY3Rpb258ZW58MHx8fHwxNzczMjUyNjQxfDA&ixlib=rb-4.1.0&q=85",
    after: "https://images.unsplash.com/photo-1711513503808-53380d724182?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3NzMyNTI2NTJ8MA&ixlib=rb-4.1.0&q=85",
    title: "Ceramic Coating - Mercedes S-Class",
    description: "9H ceramic coating with mirror-like finish"
  },
  {
    id: 3,
    before: "https://images.pexels.com/photos/13555231/pexels-photo-13555231.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://images.unsplash.com/photo-1710009444682-22b0249e75f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZ3xlbnwwfHx8fDE3NzMyNTI2NDV8MA&ixlib=rb-4.1.0&q=85",
    title: "Interior Restoration - Audi Q7",
    description: "Complete interior deep clean and conditioning"
  },
  {
    id: 4,
    before: "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxjYXIlMjBwYWludCUyMGNvcnJlY3Rpb258ZW58MHx8fHwxNzczMjUyNjQxfDA&ixlib=rb-4.1.0&q=85",
    after: "https://customer-assets.emergentagent.com/job_detailing-disciples/artifacts/7fbhs0eg_IMG_9133.HEIC",
    title: "Full Detail - Porsche 911 Targa 4S",
    description: "Paint correction and ceramic coating - Golden hour perfection"
  }
];

// REAL VERIFIED REVIEWS from Yelp - 5.0 stars, 20 reviews
export const REVIEWS_DATA = [
  {
    id: 1,
    name: "Bryan M.",
    location: "Woodland Hills, CA",
    date: "March 26, 2026",
    rating: 5,
    text: "I recently had my car detailed by Detailing Disciples, and I am absolutely blown away by the results. From the moment I dropped off my car, the service was fantastic. Fady was professional, friendly, and took the time to explain the process. When I picked up my car, it was like a brand new vehicle. The paint was so shiny and smooth, it had a deep, reflective gloss from the Ceramic Coating. The level of skill and dedication is truly top-notch.",
    vehicle: "Camaro ZL1 1LE",
    service: "Ceramic Coating"
  },
  {
    id: 2,
    name: "Seth W.",
    location: "Simi Valley, CA",
    date: "July 21, 2026",
    rating: 5,
    text: "I worked with Fady for the first time today, and it was an outstanding experience. He is patient, warm, knowledgeable, and professional. My SUV (which I had just taken up to the mountains and gotten covered in bugs and dirt) looks better than it did coming off the showroom floor. He helped me talk through some best practices going forward for maintaining the vehicle. I strongly recommend this service.",
    vehicle: "SUV",
    service: "Full Detail"
  },
  {
    id: 3,
    name: "Gary Z.",
    location: "Ann Arbor, MI",
    date: "July 17, 2026",
    rating: 5,
    text: "Fady is truly one of the best in the game. He really cares about his work and doing things the right way. He's taken care of my vehicles for years. He cleaned up my truck after months of dirt, acid rain, tree sap, dog hair, etc. He did a 2 stage paint correction, ceramic coat, interior detail, and engine bay detail. He can do paint correction with results you wouldn't believe. 11/10 would recommend.",
    vehicle: "Truck",
    service: "2-Stage Paint Correction, Ceramic Coating, Interior & Engine Bay Detail"
  },
  {
    id: 4,
    name: "Taylor S.",
    location: "Westlake Village, CA",
    date: "May 6, 2026",
    rating: 5,
    text: "Detailed my 2022 Tundra and I was amazed with the results. I have a 3 year old and had resigned that my back seat was never going to be the same. Fady restored it to like new. His attention to detail is fantastic - highly recommended.",
    vehicle: "2022 Toyota Tundra",
    service: "Interior Detail"
  },
  {
    id: 5,
    name: "Michael S.",
    location: "Los Angeles, CA",
    date: "April 3, 2026",
    rating: 5,
    text: "Detailing Disciples is the only place I trust with my 911. They have amazing attention to detail and make sure I understand what I'm paying for 100%. The owner Fady is meticulous and pays personal attention to each customer like his own family. Could not recommend Detailing Disciples more!!",
    vehicle: "Porsche 911",
    service: "Full Detail"
  },
  {
    id: 6,
    name: "Stephanie C.",
    location: "Glendale, CA",
    date: "May 27, 2026",
    rating: 5,
    text: "I had my car washed by Detailing Disciples and was blown away by not only the care taken in handling my vehicle, but the friendliness of Fady. His attitude and knowledge ensured that I would never go back to a standard car wash again, nor will I ever look elsewhere for detailing needs. Absolutely recommend and I send all my friends his way.",
    vehicle: "Sedan",
    service: "Premium Wash"
  }
];

export const FAQ_DATA = [
  {
    id: 1,
    question: "How long does ceramic coating last?",
    answer: "Our professional-grade ceramic coatings last 2-5 years depending on the product tier and maintenance. We offer packages with 2-year, 3-year, and 5-year warranties. Proper care and regular maintenance washes will maximize longevity."
  },
  {
    id: 2,
    question: "Do you offer mobile service?",
    answer: "Yes! We offer mobile detailing service within a 25-mile radius of our shop. Our mobile unit is fully equipped to handle most services at your location, including paint correction and ceramic coatings."
  },
  {
    id: 3,
    question: "How long does a full detail take?",
    answer: "Time varies by service: Express Wash (45-60 min), Basic Detail (2-3 hours), Premium Detail (4-5 hours), Paint Correction with Ceramic Coating (full day or multiple days for extensive correction)."
  },
  {
    id: 4,
    question: "What's included in interior detailing?",
    answer: "Our interior detail includes: thorough vacuum of all surfaces, steam cleaning of carpets and upholstery, leather cleaning and conditioning, dashboard and console cleaning, door jambs, odor elimination, and UV protection treatment on all surfaces."
  },
  {
    id: 5,
    question: "Do you work on all vehicle types?",
    answer: "Yes, we detail all vehicle types: cars, trucks, SUVs, motorcycles, boats, and RVs. Pricing varies based on vehicle size and condition. Contact us for a custom quote on larger vehicles."
  },
  {
    id: 6,
    question: "What's your cancellation policy?",
    answer: "We require 24-hour notice for cancellations or rescheduling. Appointments cancelled with less than 24 hours notice may be subject to a 50% cancellation fee."
  },
  {
    id: 7,
    question: "Do you offer warranties or guarantees?",
    answer: "Yes! All our services come with a satisfaction guarantee. Ceramic coating packages include product warranties ranging from 2-5 years. If you're not completely satisfied, we'll make it right."
  },
  {
    id: 8,
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards, debit cards, Apple Pay, Google Pay, and cash. Payment is due upon completion of service. We also offer package deals with discounted rates."
  }
];

export const TRUST_BADGES = [
  {
    id: 1,
    title: "5.0 Star Rating",
    subtitle: "20 Reviews on Yelp",
    icon: "star"
  },
  {
    id: 2,
    title: "Owner-Operated",
    subtitle: "Personal attention to every detail",
    icon: "award"
  },
  {
    id: 3,
    title: "Mobile Services Available",
    subtitle: "We come to you",
    icon: "truck"
  },
  {
    id: 4,
    title: "Paint-Safe Methods",
    subtitle: "Deionized water & fresh towels",
    icon: "shield-check"
  }
];

export const CONTACT_INFO = {
  phone: "(747) 320-7174",
  email: "info@detailingdisciples.com",
  address: "Simi Valley, CA",
  addressNote: "Appointments Only",
  hours: {
    weekday: "9:00 AM - 6:00 PM",
    weekend: "9:00 AM - 6:00 PM"
  },
  mobileService: "Mobile Services Available",
  serviceRadius: "Ventura County and select Los Angeles areas",
  serviceAreas: [
    "Simi Valley",
    "Thousand Oaks",
    "Westlake Village",
    "Agoura Hills",
    "Calabasas",
    "Moorpark",
    "West Hills",
    "Woodland Hills",
    "Encino",
    "Santa Monica",
    "Beverly Hills",
    "Malibu"
  ],
  socialMedia: {
    instagram: "https://www.instagram.com/thedetailingdisciples/?hl=en",
    facebook: "https://www.facebook.com/profile.php?id=61574961796039",
    yelp: "https://www.yelp.com/biz/detailing-disciples-simi-valley-2",
    tiktok: "https://www.tiktok.com/@detailing.discipl",
    google: "https://g.page/r/CbkD6ZBDY-FpEBM/review"
  }
};
